"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validators = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
exports.default = {
    Email: (lg) => {
        let rx = new RegExp("^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$");
        return rx.test(lg);
    },
    Dni: (dni) => {
        if (dni && dni.length > 4 && dni.length < 13) {
            let rx = new RegExp("^([0-9])*$");
            return rx.test(dni);
        }
    },
    Cuit: (cuit) => {
        if (typeof cuit === 'string') {
            cuit = cuit.delete('-');
        }
        if (cuit.length != 11) {
            return false;
        }
        let acumulado = 0;
        const digitos = cuit.split("");
        const digito = parseInt(digitos.pop());
        for (let i = 0; i < digitos.length; i++) {
            acumulado += parseInt(digitos[9 - i]) * (2 + (i % 6));
        }
        let verif = 11 - (acumulado % 11);
        if (verif == 11) {
            verif = 0;
        }
        return digito == verif;
    },
};
exports.validators = {
    email: (value) => {
        const rx = new RegExp("^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$");
        return rx.test(value);
    },
    cuit: (value) => {
        value = String(value || '');
        if (typeof value === 'string')
            value = value.delete('-');
        if (value.length != 11)
            return false;
        let acumulado = 0;
        const digitos = value.split("");
        const digito = parseInt(digitos.pop());
        for (let i = 0; i < digitos.length; i++) {
            acumulado += parseInt(digitos[9 - i]) * (2 + (i % 6));
        }
        let verif = 11 - (acumulado % 11);
        if (verif == 11) {
            verif = 0;
        }
        return digito == verif;
    },
    dni: (value) => {
        value = String(value || '');
        if (value && value.length > 4 && value.length < 13) {
            return new RegExp("^([0-9])*$").test(value);
        }
    },
    integer: (value) => {
        value = String(value || '');
        return Boolean(!Number(value).isNan() &&
            Number(value) === Number(value).round(0));
    },
    currency: (value) => {
        value = String(value || '');
        return Boolean(!Number(value).isNan());
    },
    number: (value) => {
        value = String(value || '');
        return Boolean(!Number(value).isNan());
    },
    date: (value) => {
        return Boolean(!dayjs_1.default(value || null).isValid());
    },
};
